import React, { Component } from 'react';
import { ButtonToolbar, Button } from 'react-bootstrap';
import CentersDropdownList from '../../centers/DropdownList';
import DateRangePickerButton from '../DateRangePickerButton';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { withTranslation } from 'react-i18next';
import LessonTypeDropdownList from './LessonTypeDropdownList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import QuerySelector from '../savedQueries/QuerySelector';
import moment from 'moment';

class Filter extends Component {
	constructor(props) {
		super(props);
		this.handleSavedQuerySelect = this.handleSavedQuerySelect.bind(this);
		this.handleCenterSelect = this.handleCenterSelect.bind(this);
		this.handleDateRangeSelect = this.handleDateRangeSelect.bind(this);
		this.handleLessonTypeSelect = this.handleLessonTypeSelect.bind(this);
		this.handleRefresh = this.handleRefresh.bind(this);

		this.state = {
			selectedSavedQuery: null
		};
	}

	getCurrentFilter() {
		const { periodFrom, periodTo, termId, schoolYearId, centerIds, lessonTypeId } = this.props;
		return {
			periodFrom,
			periodTo,
			termId,
			schoolYearId,
			centerIds,
			lessonTypeId
		};
	}

	handleSavedQuerySelect(savedQuery) {
		this.setState({ selectedSavedQuery: savedQuery });

		const defaultFilter = this.props.defaultFilterValues;

		if (savedQuery) {
			const query = savedQuery.query;

			this.props.onApplyFilter({
				periodFrom: query && query.periodFrom ? moment(query.periodFrom) : defaultFilter.periodFrom,
				periodTo: query && query.periodTo ? moment(query.periodTo) : defaultFilter.periodTo,
				termId: (query && query.termId) ? query.termId : (query && query.periodFrom) ? null : defaultFilter.termId,	 // do not use default termId if date range filter is saved in the query
				schoolYearId: (query && query.schoolYearId) ? query.schoolYearId : (query && query.periodFrom) ? null : defaultFilter.schoolYearId,
				centerIds: (query && query.centerIds) || defaultFilter.centerIds,
				lessonTypeId: (query && query.lessonTypeId) || defaultFilter.lessonTypeId
			});
		} else {
			this.props.onApplyFilter(defaultFilter); // reset to default filter
		}
	}

	handleCenterSelect(centerIds) {
		this.props.onApplyFilter({
			...this.getCurrentFilter(),
			centerIds
		});
	}

	handleDateRangeSelect({ periodFrom, periodTo, termId, schoolYearId }) {
		this.props.onApplyFilter({
			...this.getCurrentFilter(),
			periodFrom,
			periodTo,
			termId,
			schoolYearId
		});
	}

	handleLessonTypeSelect(lessonTypeId) {
		this.props.onApplyFilter({
			...this.getCurrentFilter(),
			lessonTypeId
		});
	}

	handleRefresh() {
		this.props.onApplyFilter(this.getCurrentFilter());
	}

	getSavedQueryFilters() {
		const filterValues = this.getCurrentFilter();
		const { t } = this.props;

		return {
			'Centers': {
				label: t('SavedQuery_IncludeCenters'),
				fields: { 'centerIds': filterValues['centerIds'] },
				include: true
			},
			'LessonType': {
				label: t('SavedQuery_IncludeLessonType'),
				fields: { 'lessonTypeId': filterValues['lessonTypeId'] },
				include: true
			},
			'DateRange': {
				label: t('SavedQuery_IncludeDateRange'),
				fields: {
					'periodFrom': filterValues['periodFrom'],
					'periodTo': filterValues['periodTo'],
					'termId': filterValues['termId'],
					'schoolYearId': filterValues['schoolYearId']
				},
				include: false
			}
		};
	}

	render() {
		const { t } = this.props;
		const buttonClassName = 'sm-btn-lg btn-light-grey';

		const savedQueryFilters = this.getSavedQueryFilters();

		return <ButtonToolbar className='pull-right buttons-widget'>
			<QuerySelector buttonClassName={buttonClassName} queryType='Operations'
				selectedQuery={this.state.selectedSavedQuery} onSelectQuery={this.handleSavedQuerySelect}
				filters={savedQueryFilters} onSaveQuery={this.handleSaveQuery} />
			<CentersDropdownList render='button' className={buttonClassName} filter={center => !center.isKindergarten} value={this.props.centerIds} onChange={this.handleCenterSelect} emptyLabel={t('Common_AllCenters')} />
			<LessonTypeDropdownList render='button' className={buttonClassName} value={this.props.lessonTypeId} onChange={this.handleLessonTypeSelect} emptyLabel={t('Common_AllLessonsType')} />
			<DateRangePickerButton buttonClassName={buttonClassName} currentCulture={this.props.currentCulture}
				periodFrom={this.props.periodFrom} periodTo={this.props.periodTo}
				termId={this.props.termId} terms={this.props.terms}
				schoolYearId={this.props.schoolYearId} schoolYears={this.props.schoolYears} activeSchoolYearId={this.props.activeSchoolYearId}
				onDateRangeSelect={this.handleDateRangeSelect}
			/>
			<Button className={buttonClassName} onClick={this.handleRefresh}><FontAwesomeIcon icon={faRefresh} /></Button>
		</ButtonToolbar >;
	}
}

export default withTranslation()(Filter);